export enum NotificationMetadataScreen {
  accessRequests = 'access-requests',
  content = 'content',
  createOffer = 'create-offer',
  credits = 'credits',
  explore = 'explore',
  home = 'home',
  noshow = 'noshow',
  penalty = 'penalty',
  penalties = 'penalties',
  points = 'points',
  profile = 'profile',
  rate = 'rate',
  referVenue = 'refer-venue',
  suspension = 'suspension',
  update = 'update',
  venueContent = 'venue-content',
  transaction = 'transaction',
  venueBalance = 'venue-balance',
  brandUpgradePlan = 'brand-upgrade-plan',
  collabDetails = 'collab-details',
}

export type NotificationMetadata = {
  screen?: NotificationMetadataScreen;
  notificationID?: string;
  offerID?: string;
  reservationID?: string;
  inviteID?: string;
  userID?: string;
  venueID?: string;
  agencyID?: string;
  postLink?: string;
  startDateTime?: string;
  offerEndDate?: string;
  amount?: number;
  status?: string;
  name?: string;
  content?: string;
  thumbnail?: string;
  transactionAmount?: number;
  transactionStatus?: string;
  isFirstMessage?: boolean;
  context?: string;
  type?: string;
  button?: string;
  style?: string;
  image?: string;
};

export const parseNotificationMetadata = (raw?: string | null): NotificationMetadata => {
  if (!raw) return {};

  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? (parsed as NotificationMetadata) : {};
  } catch {
    return {};
  }
};
